/* tslint:disable */
/* eslint-disable */
/**
 * Muze REST API
 * API Data backend for Muze
 *
 * The version of the OpenAPI document: 1.6.0
 * Contact: dash@muze.nyc
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    PasswordChange,
    PasswordChangeFromJSON,
    PasswordChangeToJSON,
    PatchedPhoneVerification,
    PatchedPhoneVerificationFromJSON,
    PatchedPhoneVerificationToJSON,
    PatchedUser,
    PatchedUserFromJSON,
    PatchedUserToJSON,
    PhoneVerification,
    PhoneVerificationFromJSON,
    PhoneVerificationToJSON,
    User,
    UserFromJSON,
    UserToJSON,
    UserRegistration,
    UserRegistrationFromJSON,
    UserRegistrationToJSON,
} from '../models';

export interface AccountPartialUpdateRequest {
    patchedUser?: PatchedUser;
}

export interface AccountPasswordChangeCreateRequest {
    passwordChange: PasswordChange;
}

export interface AccountPhoneVerifyPartialUpdateRequest {
    patchedPhoneVerification?: PatchedPhoneVerification;
}

export interface AccountPhoneVerifyUpdateRequest {
    phoneVerification?: PhoneVerification;
}

export interface AccountRegistrationCreateRequest {
    userRegistration: UserRegistration;
}

export interface AccountUpdateRequest {
    user: User;
}

/**
 * 
 */
export class AccountApi extends runtime.BaseAPI {

    /**
     * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.  Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
     */
    async accountPartialUpdateRaw(requestParameters: AccountPartialUpdateRequest): Promise<runtime.ApiResponse<User>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedUserToJSON(requestParameters.patchedUser),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.  Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
     */
    async accountPartialUpdate(requestParameters: AccountPartialUpdateRequest): Promise<User> {
        const response = await this.accountPartialUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Calls Django Auth SetPasswordForm save method.  Accepts the following POST parameters: new_password1, new_password2 Returns the success/fail message.
     */
    async accountPasswordChangeCreateRaw(requestParameters: AccountPasswordChangeCreateRequest): Promise<runtime.ApiResponse<PasswordChange>> {
        if (requestParameters.passwordChange === null || requestParameters.passwordChange === undefined) {
            throw new runtime.RequiredError('passwordChange','Required parameter requestParameters.passwordChange was null or undefined when calling accountPasswordChangeCreate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/password/change/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PasswordChangeToJSON(requestParameters.passwordChange),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PasswordChangeFromJSON(jsonValue));
    }

    /**
     * Calls Django Auth SetPasswordForm save method.  Accepts the following POST parameters: new_password1, new_password2 Returns the success/fail message.
     */
    async accountPasswordChangeCreate(requestParameters: AccountPasswordChangeCreateRequest): Promise<PasswordChange> {
        const response = await this.accountPasswordChangeCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async accountPhoneVerifyPartialUpdateRaw(requestParameters: AccountPhoneVerifyPartialUpdateRequest): Promise<runtime.ApiResponse<PhoneVerification>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/phone/verify/`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedPhoneVerificationToJSON(requestParameters.patchedPhoneVerification),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PhoneVerificationFromJSON(jsonValue));
    }

    /**
     */
    async accountPhoneVerifyPartialUpdate(requestParameters: AccountPhoneVerifyPartialUpdateRequest): Promise<PhoneVerification> {
        const response = await this.accountPhoneVerifyPartialUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async accountPhoneVerifyRetrieveRaw(): Promise<runtime.ApiResponse<PhoneVerification>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/phone/verify/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PhoneVerificationFromJSON(jsonValue));
    }

    /**
     */
    async accountPhoneVerifyRetrieve(): Promise<PhoneVerification> {
        const response = await this.accountPhoneVerifyRetrieveRaw();
        return await response.value();
    }

    /**
     * Delete existing verification and make new verification object. (Idempotent)
     */
    async accountPhoneVerifyUpdateRaw(requestParameters: AccountPhoneVerifyUpdateRequest): Promise<runtime.ApiResponse<PhoneVerification>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/phone/verify/`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PhoneVerificationToJSON(requestParameters.phoneVerification),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PhoneVerificationFromJSON(jsonValue));
    }

    /**
     * Delete existing verification and make new verification object. (Idempotent)
     */
    async accountPhoneVerifyUpdate(requestParameters: AccountPhoneVerifyUpdateRequest): Promise<PhoneVerification> {
        const response = await this.accountPhoneVerifyUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async accountRegistrationCreateRaw(requestParameters: AccountRegistrationCreateRequest): Promise<runtime.ApiResponse<UserRegistration>> {
        if (requestParameters.userRegistration === null || requestParameters.userRegistration === undefined) {
            throw new runtime.RequiredError('userRegistration','Required parameter requestParameters.userRegistration was null or undefined when calling accountRegistrationCreate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/registration/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserRegistrationToJSON(requestParameters.userRegistration),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserRegistrationFromJSON(jsonValue));
    }

    /**
     */
    async accountRegistrationCreate(requestParameters: AccountRegistrationCreateRequest): Promise<UserRegistration> {
        const response = await this.accountRegistrationCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.  Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
     */
    async accountRetrieveRaw(): Promise<runtime.ApiResponse<User>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.  Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
     */
    async accountRetrieve(): Promise<User> {
        const response = await this.accountRetrieveRaw();
        return await response.value();
    }

    /**
     * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.  Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
     */
    async accountUpdateRaw(requestParameters: AccountUpdateRequest): Promise<runtime.ApiResponse<User>> {
        if (requestParameters.user === null || requestParameters.user === undefined) {
            throw new runtime.RequiredError('user','Required parameter requestParameters.user was null or undefined when calling accountUpdate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/account/`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserToJSON(requestParameters.user),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Reads and updates UserModel fields Accepts GET, PUT, PATCH methods.  Default accepted fields: username, first_name, last_name Default display fields: pk, username, email, first_name, last_name Read-only fields: pk, email  Returns UserModel fields.
     */
    async accountUpdate(requestParameters: AccountUpdateRequest): Promise<User> {
        const response = await this.accountUpdateRaw(requestParameters);
        return await response.value();
    }

}
